import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { separatorOptions } from 'src/app/domainObjects/separator';

@Component({
    selector: 'app-autocomplete-field-separator',
    templateUrl: './autocomplete-field-separator.component.html',
    styleUrls: ['./autocomplete-field-separator.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteFieldSeparatorComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AutocompleteFieldSeparatorComponent implements OnInit, ControlValueAccessor {
  @Output() selectionChange = new EventEmitter<string>(); // Emits the selected option

  // options = [
  //   { text: "| (pipe)", value: "|" },
  //   { text: ": (colon)", value: ":" },
  //   { text: "; (semicolon)", value: ";" },
  //   { text: ", (comma)", value: "," },
  //   { text: ". (dot/period)", value: "." },
  //   { text: " (space)", value: " " },
  //   { text: "/ (fwd slash)", value: "/" },
  //   { text: "- (dash)", value: "-" },
  //   { text: "_ (underscore)", value: "_" }
  //   //{ text: "\\ (backslash)", value: "\\" }
  // ];
  options =separatorOptions;
  formControl = new FormControl('');
  filteredOptions!: Observable<{ text: string, value: string }[]>;

  selectedOption: string = ''; // To show text in UI while storing value

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit() {
    // Initialize filtering logic
    this.filteredOptions = this.formControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    // Emit changes to ngModel whenever the form control value changes
    this.formControl.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }
  
  // Write a new value to the element
  writeValue(value: any): void {
    const selected = this.options.find(option => option.value === value);
    this.selectedOption = selected ? selected.text : value;
    this.formControl.setValue(this.selectedOption, { emitEvent: false });
  }

  // Set the function to be called when the control receives a change event
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Set the function to be called when the control receives a touch event
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  private _filter(value: string): { text: string, value: string }[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option =>
      option.text.toLowerCase().includes(filterValue)
    );
  }
  
  onOptionSelected(value: string) {
    // this.formControl.setValue(option); // Update the form control
    // this.onChange(option); // Notify Angular Forms of the change
    //this.selectionChange.emit(value); // Emit the selection event
    const selected = this.options.find(option => option.value === value);
    if (selected) {
      this.selectedOption = selected.text;
      this.formControl.setValue(this.selectedOption, { emitEvent: false }); // Show text
      this.onChange(selected.value); // Store value in model
      this.selectionChange.emit(selected.value);
    }
  }
}
